import { Activity } from 'react'
import { Panel } from 'react-resizable-panels'

import { CollapsibleResizeHandle } from '../../components/collapsibleResizeHandle/CollapsibleResizeHandle'
import { useLayoutContext } from '../../context/layoutContext'
import { TemplateSidebar } from './TemplateSidebar'

export const TemplateSidebarPanel = () => {
  const { onChangeView, preferences } = useLayoutContext()
  const {
    templates: { isSidebarOpen },
  } = preferences

  const handleToggleSidebar = () => {
    onChangeView({
      ...preferences,
      templates: { ...preferences.templates, isSidebarOpen: !isSidebarOpen },
    })
  }

  return (
    <>
      <Activity mode={isSidebarOpen ? 'visible' : 'hidden'}>
        <Panel
          className="size-full overflow-hidden"
          id="templateModels"
          defaultSize="20%"
          minSize="5%"
        >
          <TemplateSidebar />
        </Panel>
      </Activity>
      <CollapsibleResizeHandle
        id="resizeTemplateModelsBar"
        isOpen={isSidebarOpen}
        onToggle={handleToggleSidebar}
      />
    </>
  )
}
